import { render, staticRenderFns } from "./integral-setting.vue?vue&type=template&id=72a78116&scoped=true&"
import script from "./integral-setting.vue?vue&type=script&lang=js&"
export * from "./integral-setting.vue?vue&type=script&lang=js&"
import style0 from "./integral-setting.vue?vue&type=style&index=0&id=72a78116&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a78116",
  null
  
)

export default component.exports